module.exports = __webpack_public_path__ + "img/emptytext.40251779.svg";